<script>
	import formBase from '@_system/components/base/form.vue'
	import formmain from '@_system/components/base/formmain.vue'
	import print from './lib/print.vue'
	import contract from './lib/contract.vue'
	import onlinegoodsbox from './lib/onlinegoodsbox.vue'
	import stockIndex from './lib/stock.vue'
	import parcelbox from './box/parcelbox.vue'
	import customerbox from './box/customer/list'
	
	
	export default {
		extends: formBase,
		name: 'offerForm',
		props: {

		},
		data() {
			return {
				config:{
					profitoffsetleft:10,
					profitoffsetright:10,
				},
				goodscode:[],
				customerid:null,
				companyid:null,
				parcelid:null,
				sonform:{
					formModule: {
						component: '',
						name: '',
						id: 0,
						show: false,
						controlltype: 1,
						foreingKey: {},
						extra: {},
						windowName: '',
						windowType: 'modal',
						isflow: 0,
						flowprogressid: 0,
						flowid: 0,
					
					},
					formwindowShow:false,
				},
				
				formToolbarConfig: [{
						group: 'file',
						code: 'print',
						title: '打印报价单',
						disabled: true
					},{
						group: 'file',
						code: 'contract',
						title: '打印合同',
						disabled: true
					},
					// {
					// 	group: 'tool',
					// 	code: 'editcustomer',
					// 	title: '编辑客户',
					// 	disabled: false
					// },
					// {
					// 	group: 'file',
					// 	code: 'load',
					// 	title: '载入',
					// 	disabled: true
					// }
				],
				goodsprofit:[],
				toolname: '',
				totalShow: false,

				printShow: false,
				contractShow: false,
				mainForm: this,
				exportData: [],
				loading: false,
				deliveryList: [],
				weight: 0,
				province: 0,
				coefficient: 1,
				onlinegoodsidShow: false,
				onlinegoodsboxShow: false,
				copybuff: false
			}

		},

		watch: {

		},
		computed: {

		},
		render(h) {
			this.$slots.plug = [
				this.sonform.formwindowShow ? 
				<formwindow formConfig={this.sonform.formModule} onBack={this.sonformBack} /> : "",
				<customerbox ref="customerbox" onSubmit={this.customerboxSubmit} />,
				<stock-index ref="stockIndex" goodscode={this.goodscode}  />,
				<vxe-modal v-model={this.printShow} width="80%" height="80%" title="报价单预览" transfer show-close destroy-on-close>
					<print id={this.id} name={this.name} mainForm={this.mainForm} />
				</vxe-modal>,
				<vxe-modal v-model={this.contractShow} width="80%" height="80%" title="报价单预览" transfer show-close destroy-on-close>
					<contract id={this.id} name={this.name} mainForm={this.mainForm} />
				</vxe-modal>,
				<parcelbox ref="parcelbox"  onSubmit={this.parcelboxSubmit}  />,
				this.onlinegoodsboxShow ?
				<onlinegoodsbox form={this} onBack={this.onlinegoodsboxBack} onSubmit={this.onlinegoodsboxSubmit} /> :
				''
			]
			return formBase.render.call(this, h)
		},
		created() {
			this.formToolbarConfig.forEach((item) => {
				if (this.id == 0) {
					if (item.code == 'print') {
						item.disabled = false
					}
					if (item.code == 'contract') {
						item.disabled = true
					}
					if (item.code == 'load') {
						item.disabled = false
					}
				} else {
					if (item.code == 'print') {
						item.disabled = false
					}
					if (item.code == 'contract') {
						item.disabled = false
					}
					if (item.code == 'load') {
						item.disabled = true
					}
				}
			})
		},
		mounted() {

		},
		methods: {
			quickaddButton(){
				let insertdata = []
				let insertdatacode = []
				// let code = 'zh100605050003'
				let code = this.fApi.getValue('quickadd')
				code = code.trim()
				if(!code){
					this.$message.error('请输入内容')
					return
				}
				const rows = code.split(/\s+/); 
				const goodsdata = [];
				for (let i = 0; i < rows.length; i += 3) {
					goodsdata.push(rows.slice(i, i + 3))
				}
				goodsdata.forEach((item)=>{
					if(item[0]){
						insertdatacode.push(item[0])
					}
				})
				
				// console.log(JSON.stringify(goodsdata) );
				// return
				
				let totalpromise = []
				for(let i=0; i < goodsdata.length; i++){
					if(!goodsdata[i][0]){
						continue
					}
					totalpromise.push(()=>{
						return new Promise((totalreslove)=>{
							let code = goodsdata[i][0]
							if(!code){
								return
							}
							const promise1 = ()=>{
								return new Promise((reslove)=>{
									this.$api.goods.list({
										mode:'box',
										index:1,
										group:'offer_goods',
										code:code,
									}).then((res)=>{
										reslove(res)
									})
								})
							}
							const promise2 = ()=>{
								return new Promise((reslove)=>{
									this.$api.goodsonline.list({
										mode:'box',
										index:2,
										group:'offer_goods',
										code:code,
									}).then((res)=>{
										reslove(res)
									})
								})
							}
							
							Promise.all([promise1(), promise2()])
								.then((results) => {
									console.log(results)
									let data = []
									if(results[0].list.length){
										// let exist = results[0].list.find((item)=>{
										// 	return item.code == code
										// })
										// if(exist){
										// 	data.push(exist)
										// }										
										data.push(results[0].list[0])
									}else if( results[1].list.length ){
										let exist = results[1].list.find((item)=>{
											return item.code == code
										})
										if(exist){
											data = results[1].list.filter((item)=>{
												return item.parentid == exist.id
											})
										}
									}
									if(!data.length){
										this.$message.error('未查询到商品信息')
										totalreslove()
										return
									}
									
									// let $son_offer_goods = this.fApi.el('$son_offer_goods')
									if(parseInt(goodsdata[i][1])){
										data = data.map((item)=>{
											item.num = goodsdata[i][1]
											return item
										})
									}
									if(parseFloat(goodsdata[i][2])){
										data = data.map((item)=>{
											item.taxfreight = goodsdata[i][2]
											return item
										})
									}
									insertdata.push(data)
									// console.log(insertdata)
									totalreslove()
									this.fApi.setValue('quickadd',null)							
								}).catch(error => {
									this.$message.error(error)
								});
						})
					})
				}
				totalpromise = totalpromise.map((item)=>{
					return item()
				})
				this.loading = true
				
				Promise.all(totalpromise).then(()=>{
					this.loading = false
					let orderinsertdata = []
					console.log(insertdata,insertdatacode)
					insertdatacode.forEach((item)=>{
						let exist = insertdata.find((_item)=>{
							return item == _item[0].code || _item[0].groupcode && (_item[0].groupcode == item)
						})
						if(exist){
							orderinsertdata = orderinsertdata.concat(exist)
						}
					})
					
					orderinsertdata.forEach((item)=>{
						let $son_offer_goods = this.fApi.el('$son_offer_goods')
						let data = [item]
						$son_offer_goods.add({
							data:data
						})
						this.$nextTick(()=>{							
							if(parseFloat( item.taxfreight )){
								let tabledata = $son_offer_goods.store.table.getTableData().fullData
								data.forEach((item)=>{
									let target = tabledata.find((_item) => {
										return _item.goodscode == item.code
									})										
									if(target){
										setTimeout(()=>{
											target.taxfreight = item.taxfreight											
											this.computeRow(target,'taxfreight')
										},0)	
									}
								})
							}
						})
					})	
				})
			},
			customercodeButton(){
				this.$refs.customerbox.modal_show()
			},
			customerboxSubmit(e){
				if(e.data){
					this.fApi.setValue('customerid',e.data.customerid)
					this.fApi.setValue('customeraddressid',e.data.addresswlnid)
					this.fApi.setValue('customercode',e.data.code)
					this.fApi.setValue('customername',e.data.customername)
					this.fApi.setValue('customerphone',e.data.phone)
					this.fApi.setValue('customercompany',e.data.title)
					this.fApi.setValue('customeraccountnumber',e.data.account)
					this.fApi.setValue('customertaxid',e.data.taxid)
					this.fApi.setValue('customerbank',e.data.bank)
					this.fApi.setValue('customeraddress',e.data.province + e.data.city + e.data.area + e.data.street + e.data.address)
					let province = [
						window.systemMethods.getEmunId('city',e.data.province),
						window.systemMethods.getEmunId('city',e.data.city),
						window.systemMethods.getEmunId('city',e.data.area),
					]
					// console.log(province)
					this.fApi.setValue('province',province)
					this.fApi.setValue('freight', null)
					this.fApi.setValue('parcelid', null)
					this.fApi.setValue('parcelname', null)
				}
			},
			
			online_offer_goods() {
				this.onlinegoodsboxShow = true
			},
			onlinegoodsboxSubmit(e) {
				// console.log(e)
				this.onlinegoodsidShow = false
				let $son_offer_goods = this.fApi.el('$son_offer_goods')
				$son_offer_goods.add(e)
			},
			onlinegoodsboxBack() {
				this.onlinegoodsboxShow = false

			},
						
			beforeSubmit(formData, next) {
				let province = this.fApi.getValue('province')
				province = province?province:this.fApi.getValue('temprovince')
				if(province){
					formData.bidcoefficient = this.coefficient
					formData.canprint = 1
					next()	
				}else{
					this.$message.error('省份或临时省份不能都为空')
					this.loading = false
				}
				
			},
			beforeInit(next) {
				this.$api.goodsprofit.listprofit().then((res) => {
					this.goodsprofit = res.list
					this.config = res.profitConfig
					if (this.id == 0) {
						this.$api.bidcoefficient.getStaffCoefficient().then((res) => {
							this.coefficient = 1 + res / 100
							next()
						})
					} else {
						next()
					}
				})
			},
			beforeFormCreate(rule) {
				rule.forEach((item) => {
					// if (item.field == 'discount') {
					// 	let marks = {}
					// 	marks["0"] = "0"
					// 	marks[this.config.profitoffsetright.toString()] = this.config.profitoffsetright.toString()
					// 	marks[(-this.config.profitoffsetleft).toString()] = (-this.config.profitoffsetleft).toString()
					// 	item.props.max = this.config.profitoffsetright
					// 	item.props.min = -this.config.profitoffsetleft
					// 	item.props.marks = marks
					// }
					if (item.field == 'additionalcosts') {
						delete item.props.min
					}
					if(item.field=='$son_offer_goods'){
						item.props.formConfig = {
							items:[{
								field:'goodscode',
								title:'商品编码',
								itemRender:{
									name:'$input',
									size:'mini',
								}
							},{
								field:'goodsname',
								title:'商品名称',
								itemRender:{
									name:'$input',
									size:'mini',
								}
							},{
								field:'goodsmodel',
								title:'规格型号',
								itemRender:{
									name:'$input',
									size:'mini',
								}
							},{
								itemRender:{
									name:'$button',
									props:{
										content:'查询'
									},
									events:{
										click:this.offergoodssearch
									}
								}
							},{
								itemRender:{
									name:'$button',
									props:{
										content:'重置'
									},
									events:{
										click:this.offergoodsreset
									}
								}
							}]
						}
					}
				})
			},
			offergoodssearch(e){
				let table = this.fApi.el('$son_offer_goods')
				let fullData = table.getTableData().fullData
				let data = e.data
				let targetrow = []		
				//console.log(e)
				fullData.forEach((row) => {
					let buff = true
					for(let i in data){
						if(!data[i]){
							continue
						}
						if( !(row[i] && row[i].indexOf(data[i])!==-1) ){
							buff = false
						}				
					}
					if(buff){
						targetrow.push(row)
					}
				})
				if(targetrow.length!=0){
					table.getGrid().scrollToRow(targetrow[0])
					table.getGrid().setCurrentRow(targetrow[0])
				}
				
			},
			offergoodsreset(e){
				let table = this.fApi.el('$son_offer_goods')
				let fullData = table.getTableData().fullData
				fullData.forEach((row) => {
					table.getGrid().setCurrentRow(row)
				})
				let data = e.data
				for(let i in data){
					data[i] = null
				}
			},
			afterGet(res) {
				this.coefficient = res.bidcoefficient
				
			},
			formBack() {
				// let formname = this.formModule.name
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				// if (e.type != 'cancle') {
				// 	if (formname == 'customer') {

				// 		let customercode = this.fApi.el('customercode')
				// 		customercode.store.box[0].reload()
				// 	}
				// }
			},
			toolbarClick(e) {
				if (e == 'print') {
					this.printShow = true
				}
				if (e == 'contract') {
					this.$api.offer.cancontract({id:this.id}).then(()=>{
						this.contractShow = true
					})
				}
				if (e == 'editcustomer') {
					let customercode = this.fApi.getValue('customercode')
					if(!customercode){
						this.$message.error('客户编码不存在')
						return
					}
					this.loading = true
					this.$api.crmcustomer.getbycode({code:customercode}).then((res)=>{
						this.sonform.formModule = {
							name: 'crmcustomer',
							id: res.id,
							controlltype: 2,
							windowName: '编辑客户',
							foreingKey: {},
							extra: {}
						}
						this.sonform.formwindowShow = true
						this.loading = false
					},()=>{
						this.loading = false
					})
				}
			},
			sonformBack(e){
				this.sonform.formwindowShow = false
				console.log(e)
				
			},
			
			
			regestEvent(rule, fApi) {
				let $son_offer_goods = fApi.el('$son_offer_goods')
				$son_offer_goods.notice = `
					<div class="flex" style="flex-direction:column;">	
						<span style="margin-left:10px;color:#409EFF">快捷添加使用方法：输入编码如:【1032150003】【zh100605050003】 或 复制excel列表【第1列:商品编码，第2列:数量，第3列:含税单价】空值取0必须保证3列</span>				
						<div class="flex" style="align-items: center;">
							<span style="padding-left:10px;">商品编码背景色：</span>
							<span style="background-color:#ffffff;width:10px;height:10px;margin-right:5px;border: 1px solid black;"></span>
							<span style="margin-right:10px;color:#000000">无最近采购价</span>
							<span style="background-color:#909399;width:10px;height:10px;margin-right:5px;border: 1px solid black;"></span>
							<span style="margin-right:10px;color:#000000">采购价超过6个月</span>
							<span style="background-color:#409EFF;width:10px;height:10px;margin-right:5px;border: 1px solid black;"></span>
							<span style="margin-right:10px;color:#000000">采购价超过3个月</span>
							<span style="background-color:#67C23A;width:10px;height:10px;margin-right:5px;border: 1px solid black;"></span>
							<span style="margin-right:10px;color:#000000">采购价3个月内</span>	
						</div>
						<span style="margin-left:10px;color:#F56C6C">3个月价格未更新的品，若库存大于订单，销售直接报价;若库存小于订单，且该SKU订单金额小于300元，销售直接报价:其余情况 咨询采购</span>				
					</div>
				`
				$son_offer_goods.store.form = this
				$son_offer_goods.gridOptions.cellStyle = ({
					row,column
				}) => {
					if (!row.bida) {
						return {
							backgroundColor: '#C0C4CC',
							color: '#ffffff'
						}
					}
					if (!this.profitmargin(row)) {
						return {
							backgroundColor: 'rgb(253, 226, 226)',
						}
					}
					if (row.readrategrossprofit <= 0 || row.rategrossprofit <= 0) {
						return {
							backgroundColor: 'rgb(253, 226, 226)',
						}
					}					
					if (column.property == 'goodscode') {
						if (row['purchasestockbilltime']) {
							let timestamp = new Date().getTime()/1000
							let diff = timestamp - row['purchasestockbilltime']
							//大于6个月
							if( diff >= 15759360){
								return {
									backgroundColor: '#C0C4CC',
									color: '#ffffff'
								}
							}
							//大于3个月
							if( diff >= 7879680){
								return {
									backgroundColor: 'rgb(179, 216, 255)'
								}
							}
							//大于0个月
							return {
								backgroundColor: 'rgb(225, 243, 216)'
							}
						}
					}
				}
				if(this.id!=0){
					this.fApi.setValue('islock',1)
				}else{
					this.$api.config.get(0,{module:'offer'}).then((res)=>{
						let configdata = res.config?res.config:{}
						configdata.city = (configdata.city && Array.isArray(configdata.city)) ? configdata.city.map((item)=>{
							return parseInt(item)
						}):null
						// console.log(configdata)
						this.fApi.setValue('province', configdata.city)
						if(configdata.companyaccount){
							this.$api.company.list({
								mode:'box',
								index:1,
								inst_account:configdata.companyaccount,
							}).then((data)=>{
								if(data.list.length){
									this.boxSubmit({
										formCreateInject:{field:'companyname'},
										moduleName:'company',
										data:data.list[0]
									})
								}						
							})
						}

					})
					this.fApi.setValue('islock',0)
					
					
					if(this.extra.customercode){
						this.loading = true
						this.$api.crmcustomer.listerpcustomer({
							condition:this.extra.customercode
						}).then((res)=>{
							if(res.list.length){
								this.customerboxSubmit({data:res.list[0]})
							}
							this.loading = false
						},()=>{
							this.loading = false
						})
					}
					
					
				}
			},
			toolsSubmit(e) {
				if (e.code == 'batchmodify') {
					this.getAmount('pretaxfreight')
					//this.tmprice_offer_goods()
					
					// var table = e.table
					// var fullData = table.getTableData().fullData
					// fullData.forEach((item) => {
					// 	if(item.computertype==8106){
					// 		item.orderprice_tm = 1
					// 		item.tmdiscount_canedit = 1
					// 		item.orderprice = item.tmprice
					// 	}else{
					// 		item.orderprice_tm = 0
					// 	}
					// 	if (item.orderprice_tm) {
					// 		this.computemethod.getInitialrategrossprofit(item)
					// 	} else {
					// 		this.computemethod.resetInitialrategrossprofit(item)
					// 	}
					// 	this.computemethod.getAmount(item)
					// })
				}
			},
			cellStyle({
				row
			}) {
				console.log(row)
			},
			offerGoodsImporttemplate() {
				this.$store.commit('getTemplate', 'offer_goods')
			},
			parcelboxSubmit(e){					
				this.fApi.setValue('freight', e.data.targettPrice)
				this.fApi.setValue('parcelid', e.data.emunid)
				this.fApi.setValue('parcelname', e.data.distrParamName)
				//this.fApi.setValue('warehouse', e.data.warehouseid)
			},
			parcelnameButton(){
				let province = this.fApi.getValue('province')
				let warehouse = this.fApi.getValue('warehouse')
				let store = this.fApi.getValue('store')
				province = province?province:this.fApi.getValue('temprovince')
				if (province && store) {
					this.loading = true
					this.$api.parcel.listCheck({
						target: province[0],
						warehouse: warehouse,
						store: store,
					}).then((res) => {
						this.loading = false
						this.deliveryList = res
						this.getBestParcelid()
						this.$refs.parcelbox.deliveryList = this.deliveryList
						this.$refs.parcelbox.initList()
						this.$refs.parcelbox.box.alertBox()
					},()=>{
						this.loading = false
					})
				} else {
					this.$message.error('省市区，仓库，开票店铺 必填')
					this.deliveryList = []
				}				
				//console.log(this.deliveryList)
			},
			getstock_offer_goods(){
				let $son_offer_goods = this.fApi.el('$son_offer_goods')
				let data = $son_offer_goods.store.table.getTableData().fullData
				this.goodscode = data.map((item)=>{
					return {
						goodscode:item.goodscode,
						num:item.num
					}
				})
				this.$nextTick(()=>{
					this.$refs.stockIndex.modal_show()
				})
			},
			bestprice_offer_goods(){
				let $son_offer_goods = this.fApi.el('$son_offer_goods')
				let data = $son_offer_goods.store.table.getTableData().fullData
				data.forEach((item) => {
					item.taxfreight = this.roundPriceAuto(item.taxfreight)
					this.computeRow(item,'taxfreight')
				})
			},
			copygoodslist_offer_goods() {
				let table = this.fApi.el('$son_offer_goods')
				let fullData = table.getTableData().fullData
				let textarr = []
				fullData.forEach((item)=>{
					let text = item.goodscode + '\t' + item.num + '\t' + item.taxfreight + '\t' + item.taxfreight + '\t' + item.amount
					textarr.push(text)
				})
				this.$copyText(textarr.join('\n')).then(() => {
					this.$message.success('复制成功')
				}, () => {
					this.$message.success('复制失败')
				})
				// console.log(textarr.join('\n'))
			},
			getBestParcelid(){
				let weight = this.fApi.getValue('weight')
				let logistics = []
				weight = Math.ceil(weight * 1.1)
				//console.log(this.deliveryList,weight)
				this.deliveryList.forEach((item) => {
					let distrFeeRangeList = item.distrFeeRangeList
					distrFeeRangeList.forEach((_item)=>{
						if (_item.min <= weight && _item.max > weight) {
							item.targetItem = _item
							logistics.push(item)
						}
					})	
				})
				
				logistics.forEach((item)=>{
					item.targettPrice = 0
					let firstWeightDiff = weight - item.targetItem.firstWeight
					if(firstWeightDiff <= 0){
						item.targettPrice = item.targetItem.fee
					}else{
						item.targettPrice = item.targetItem.fee + firstWeightDiff * item.targetItem.nextFee
					}
					item.targettPrice = item.targettPrice.toFixed(2)
				})
				logistics = this.$Lodash.sortBy(logistics, item=>parseFloat(item.targettPrice))
				this.deliveryList = logistics
				
				
				if(this.fApi.getValue('islock')){
					return
				}
				//console.log(logistics,123123)
				if(logistics.length!=0){
					this.fApi.setValue('freight', logistics[0].targettPrice)	
					this.fApi.setValue('parcelid', logistics[0].emunid)
					this.fApi.setValue('parcelname', logistics[0].distrParamName)
					//this.fApi.setValue('warehouse', logistics[0].warehouseid)
				}							
			},
			afterBoxSubmit(e) {
				// console.log(e)
				if (e.moduleName == 'customer') {
					this.customerid = e.data.id
				}
				if (e.moduleName == 'company') {
					this.companyid = e.data.id
				}
			},
			// customercodeChange() {
			// 	this.getDelivery()
			// },


			//====================
			
			gettargetprofit(row){
				let targetprofit = null
				let defaultprofit = this.goodsprofit.find((item)=>{
					return item.isdefault = 5
				})
				if(defaultprofit){
					targetprofit = defaultprofit
				}
				this.goodsprofit.forEach((item)=>{
					if(item.isdefault != 5){
						let target = item.goodsprofit_goods.find((_item)=>{
							return _item.goodsid == row.goodsUid
						})
						if(target){
							targetprofit = item
						}
					}
				})
				return targetprofit				
			},
						
			intigoods(row){
				let targetprofit = this.gettargetprofit(row)
				if(!targetprofit){
					row.initialrategrossprofit = 0
					row.orderprice = 0					
					row.rategrossprofit = 0
					row.targetprofitid = 0
					return 100
				}
				row.preamount = row.preamount ? row.preamount : 0
				// console.log(targetprofit,444)
				let profititem = this.getinitialrategrossprofit(targetprofit.goodsprofit_detail,row.preamount)
				// console.log(profititem,123123)
				if(!profititem){
					row.initialrategrossprofit = 0
					row.orderprice = 0
					row.rategrossprofit = 0
					row.targetprofitid = 0
					return 100
				}
				// console.log(profititem)
				if(profititem.id != row.targetprofitid){
					let currentinitialrategrossprofit = row.initialrategrossprofit
					row.initialrategrossprofit = profititem.profit
					row.targetprofitid = profititem.id
					row.orderprice = parseFloat(row.bida) / (1 - parseFloat(row.initialrategrossprofit/100))
					row.orderprice = this.canToFixed(row.orderprice,4)
					row.rategrossprofit = row.initialrategrossprofit						
					if(profititem.profit > currentinitialrategrossprofit){
						return 100
					}			
					return 1
				}
				return 100
			},
			islockChange(){
				this.getAmount('amount')
			},
			freightChange(){
				this.getAmount('freight')
			},
			discountChange() {
				this.getAmount('rategrossprofit')				
			},
			tmdiscountChange() {
				this.getAmount('tmdiscount')				
			},
			taxChange() {
				this.getAmount('tax')
			},
			computeRow(row,changefield,initgoodstime = 2,computeForm = true){
				let islock = this.fApi.getValue('islock')
				if(islock == 1){
					return
				}
				let tax = this.fApi.getValue('tax')
				tax = tax?parseFloat(tax):0
				let freight = this.fApi.getValue('freight')
				freight = freight?parseFloat(freight):0

				
				let totalweight = 0
				let table = this.fApi.el('$son_offer_goods')
				let fullData = table.getTableData().fullData
				fullData.forEach((row) => {
					row.goodsweight = row.goodsweight?parseFloat(row.goodsweight):0
					row.num = row.num?parseFloat(row.num):0
					totalweight += row.goodsweight * row.num
				})

				let expressbid  = 0
				if(totalweight){
					expressbid = (row.goodsweight)/totalweight * freight
					// if(row.num){
					// 	expressbid = expressbid/row.num
					// }
				}

				let comprehensivebid = parseFloat(row.bida) + parseFloat(expressbid)
				comprehensivebid = comprehensivebid?comprehensivebid:0
				// console.log(row.bida,expressbid,comprehensivebid)
				//console.log(row.computertype,comprehensivebid)

				if(changefield == 'pretaxfreight' || changefield == 'tax' || changefield == 'num'){
					row.taxfreight = parseFloat(row.pretaxfreight) * (tax/100 + 1)
					row.preamount = this.computePreAmount(row)
					row.amount = this.computeAmount(row)
					if(row.pretaxfreight){
						row.rategrossprofit = (parseFloat(row.pretaxfreight) - comprehensivebid ) / parseFloat(row.pretaxfreight) * 100
					}
				}
				if(changefield == 'taxfreight'){
					row.pretaxfreight = parseFloat(row.taxfreight)/(tax/100 + 1)
					row.preamount = this.computePreAmount(row)
					row.amount = this.computeAmount(row)
					if(row.pretaxfreight){
						row.rategrossprofit = (parseFloat(row.pretaxfreight) - comprehensivebid) / parseFloat(row.pretaxfreight) * 100
					}
				}
				if(changefield == 'preamount'){
					row.pretaxfreight = parseFloat(row.preamount)/row.num
					row.taxfreight = parseFloat(row.pretaxfreight) * (tax/100 + 1)
					row.amount = this.computeAmount(row)
					if(row.pretaxfreight){
						row.rategrossprofit = (parseFloat(row.pretaxfreight) - comprehensivebid) / parseFloat(row.pretaxfreight) * 100
					}
				}
				if(changefield == 'amount'){
					row.taxfreight = parseFloat(row.amount)/row.num
					row.pretaxfreight = parseFloat(row.taxfreight)/(tax/100 + 1)
					row.preamount = this.computePreAmount(row)
					if(row.pretaxfreight){
						row.rategrossprofit = (parseFloat(row.pretaxfreight) - comprehensivebid) / parseFloat(row.pretaxfreight) * 100
					}
				}
				if(row.computertype == 8105){
					if(changefield == 'rategrossprofit'){
						let discount = this.fApi.getValue('discount')
						row.rategrossprofit = parseFloat(row.initialrategrossprofit) + parseFloat(discount)
						row.pretaxfreight = comprehensivebid / (1 - row.rategrossprofit/100)
						row.preamount = this.computePreAmount(row)
						row.taxfreight = parseFloat(row.pretaxfreight) * (tax/100 + 1)
						row.amount = this.computeAmount(row)
					}
					if(changefield == 'freight'){
						row.pretaxfreight = comprehensivebid / (1 - row.rategrossprofit/100)
						row.preamount = this.computePreAmount(row)
						row.taxfreight = parseFloat(row.pretaxfreight) * (tax/100 + 1)
						row.amount = this.computeAmount(row)
					}
				}
				if(row.computertype == 8106){
					if(changefield == 'tmdiscount'){
						let tmdiscount = this.fApi.getValue('tmdiscount')
				
						row.tmdiscount = tmdiscount/10
						let minDiscount =  (comprehensivebid/0.75) / row.tmprice * 10
						let amount = row.tmprice * row.num
						//console.log(amount,row.tmdiscount)
						if (amount <= 500) {
							row.tmdiscount = Math.max(10, row.tmdiscount)
						} else if (amount <= 1000) {
							row.tmdiscount = Math.max(9.5, row.tmdiscount)
						} else {
							row.tmdiscount = Math.max(9, row.tmdiscount)
						}
						row.tmdiscount = Math.max(minDiscount, row.tmdiscount)
						row.tmdiscount = this.canToFixed(row.tmdiscount,2)
						
						row.pretaxfreight = (row.tmprice * row.tmdiscount/10).toFixed(4)	
						row.preamount = this.computePreAmount(row)
						row.taxfreight = parseFloat(row.pretaxfreight) * (tax/100 + 1)
						row.amount = this.computeAmount(row)
						if(row.pretaxfreight){
							row.rategrossprofit = (parseFloat(row.pretaxfreight) - comprehensivebid) / parseFloat(row.pretaxfreight) * 100
						}
					}
					if(changefield == 'freight'){
						row.taxfreight = parseFloat(row.pretaxfreight) * (tax/100 + 1)
						row.preamount = this.computePreAmount(row)
						row.amount = this.computeAmount(row)
						if(row.pretaxfreight){
							row.rategrossprofit = (parseFloat(row.pretaxfreight) - comprehensivebid ) / parseFloat(row.pretaxfreight) * 100
						}
					}
				}
				
				row.pretaxfreight = this.canToFixed(row.pretaxfreight,4)
				row.taxfreight = this.canToFixed(row.taxfreight,4)
				row.preamount = this.canToFixed(row.preamount,4)
				row.amount = this.canToFixed(row.amount,4)
				row.rategrossprofit = this.canToFixed(row.rategrossprofit,2)
				row.comprehensivebid = comprehensivebid
				row.comprehensiveamount = comprehensivebid * row.num
				
				if(row.computertype == 8105){
					if(changefield != 'pretaxfreight' && changefield != 'taxfreight' && changefield != 'preamount' && changefield != 'amount'){
						if(row.preamount && initgoodstime > 0){						
							initgoodstime -= this.intigoods(row)
							this.computeRow(row,'rategrossprofit',initgoodstime) //最多执行2次 intigoods 
							return
						}
					}
				}
				if(computeForm){
					this.computeForm()
				}
			},
			computePreAmount(row){
				return parseFloat(row.pretaxfreight).toFixed(4) * row.num
			},
			computeAmount(row){
				
				return parseFloat(row.taxfreight).toFixed(4) * row.num
			},
			// getinterval(){
				
			// },
			
			computeForm(){
				let islock = this.fApi.getValue('islock')
				if(islock == 1){
					return
				}
				let totalweight = 0
				let totalnum = 0
				let totalpreamount = 0
				let totalamount = 0
				let totalcomprehensivebid = 0
				
				let table = this.fApi.el('$son_offer_goods')
				let fullData = table.getTableData().fullData

				fullData.forEach((row) => {
					let goodsweight = row.goodsweight?parseFloat(row.goodsweight):0
					let num = row.num?parseFloat(row.num):0
					totalweight += goodsweight * num
					totalnum += num
					totalpreamount += parseFloat(row.preamount)
					totalamount += parseFloat(row.amount)
					totalcomprehensivebid += parseFloat(row.comprehensiveamount)
				})
				this.fApi.setValue('weight',totalweight)
				this.fApi.setValue('num',totalnum)
				this.fApi.setValue('pretaxprice',totalpreamount)
				this.fApi.setValue('price',totalamount)
				this.fApi.setValue('bid',totalcomprehensivebid)
				let totalprofit = totalpreamount - totalcomprehensivebid
				this.fApi.setValue('profit',totalprofit)
				if(totalpreamount){
					this.fApi.setValue('rategrossprofit',this.canToFixed(totalprofit/totalpreamount*100,4))
				}else{
					this.fApi.setValue('rategrossprofit',0)
				}
				//console.log(totalpreamount,totalcomprehensivebid,12312312)
				
			},
			getinitialrategrossprofit(detail,amount){				
				amount = parseFloat(amount)
				let profititem = null
				detail.forEach((item)=>{
					if(parseFloat(item.minamount) <= amount && (parseFloat(item.maxamount) > amount || !parseFloat(item.maxamount))){
						// console.log(item,'detail')
						profititem = item
					}
				})
				
				return profititem
			},
			
			onlinecodeButton(component) {
				let code = this.fApi.getValue('onlinecode')
				if (code) {
					component.el.loading = true
					this.$api[this.name].listTrades(0,{code:code}).then((res) => {
						if (res.data.length == 0) {
							this.fApi.setValue('code', null)
							this.$message.error('暂无订单信息')
							component.el.loading = false
						} else {
							// let $son_offer_goods = this.fApi.el('$son_offer_goods')
							let province = this.fApi.el('province').labelTovalue(res.data.tp_receiver_state)
							if(!province){
								this.$message.error('未匹配到省市区 请手动选择')
							}
							let city = this.fApi.el('province').labelTovalue(res.data.tp_receiver_city,province)
							let district = this.fApi.el('province').labelTovalue(res.data.tp_receiver_town,city)
							this.fApi.setValue('province', [province, city, district])
							if(res.data.store){
								this.$api.company.list({
									mode:'box',
									index:1,
									store:res.data.store,
								}).then((data)=>{
									if(data.list.length){
										this.boxSubmit({
											formCreateInject:{field:'companyname'},
											moduleName:'company',
											data:data.list[0]
										})
									}
									this.addonlineordergoods(res)
								})
							}else{
								this.addonlineordergoods(res)
							}
							this.$nextTick(()=>{
								this.getAmount('pretaxfreight')
							})
						}
						component.el.loading = false
					},()=>{
						component.el.loading = false
					})
				} else {
					if (this.loadHandle) {
						this.loadHandle.close()
					}
					this.$message.error('请填写订单编号')
				}
			},
			addonlineordergoods(res){
				let $son_offer_goods = this.fApi.el('$son_offer_goods')
				let olddata = $son_offer_goods.store.table.getTableData().fullData
				olddata.forEach((item) => {
					$son_offer_goods.store.table.remove(item)
				})
				//console.log(res,123123)
				res.goods.forEach((item) => {
					let obj = {}
					obj.goodsid = item.id
					obj.goodscode = item.code
					obj.goodsname = item.name
					obj.goodsmodel = item.model
					obj.price = item.price
					obj.pretaxfreight = item.orderprice
					obj.tbprice = item.tbprice
					obj.tmprice = item.tmprice
					obj.bid = item.bid
					obj.goodsunit = item.unit
					obj.goodsUid = item.goodsUid
					obj.goodsweight = item.weight
					obj.num = item.num
					obj.preamount = item.num * item.orderprice
					obj.amount = 0
					obj.bida = item.bida
					obj.bidb = item.bidb
					obj.orderprice_tm = 0
					obj.computertype = 8105
					obj.purchasestockbill = item.purchasestockbill
					obj.purchasestockbilltime = item.purchasestockbilltime
					if (!obj.bida) {
						obj.bida = item.bid ? item.bid : null
						obj.autodelete = true
						obj.autodeletemessage = '缺少供应商价格'
					}
					if (!obj.bida) {
						obj.bida = item.tbprice ? item.tbprice * 0.5 : null
					}
					this.intigoods(obj)
					this.computeRow(obj,'pretaxfreight')
					$son_offer_goods.store.table.insertAt(obj)
					
				})
				this.computeForm()
			},

			tableInsert(e) {
				// console.log(e)
				if (e.moduleName == 'offer_goods') {
					//e.obj.orderprice = e.data.tmprice					
					e.obj.bida = e.data.bida
					e.obj.bidb = e.data.bidb
					e.obj.goodstype = e.data.goodstype
					e.obj.goodsUid = e.data.goodsUid
					if(e.data.import_num){
						e.obj.num = e.data.import_num
					}else if(e.data.num){
						e.obj.num = e.data.num
					}else{
						e.obj.num = 0
					}
					e.obj.rategrossprofit = 0
					e.obj.pretaxfreight = 0
					e.obj.taxfreight = 0
					e.obj.preamount = 0
					e.obj.amount = 0
					e.obj.orderprice_tm = 0
					e.obj.computertype = 8105
					e.obj.purchasestockbill = e.data.purchasestockbill_a
					e.obj.purchasestockbilltime = e.data.purchasestockbilltime_a
					if (!e.obj.bida) {
						e.obj.bida = e.data.bid ? e.data.bid : null
						e.obj.autodelete = true
						e.obj.autodeletemessage = '缺少供应商价格'
					}
					if (!e.obj.bida) {
						e.obj.bida = e.data.tbprice ? e.data.tbprice * 0.5 : null
					}
					this.intigoods(e.obj)
					// console.log(e.obj,11111111111)						
				}
			},
			afterTableInsert(e) {
				if(e.obj.row.autodelete){
					e.table.remove(e.obj.row)
					this.$message.error(e.obj.row.autodeletemessage)
					return
				}
				if (e.moduleName == 'offer_goods') {
					this.computeRow(e.obj.row,'rategrossprofit')
					this.getAmount('pretaxfreight')
				}
			},
			aftertabledelete(e) {
				switch (e.moduleName) {
					case 'offer_goods':
						this.getAmount('pretaxfreight')
						break;
				}
			},
			getAmount(field){
				let table = this.fApi.el('$son_offer_goods')
				let fullData = table.getTableData().fullData
				fullData.forEach((row) => {
					this.computeRow(row,field,2,false)
				})	
				this.computeForm()
			},
			
			tablefieldChange(e) {
				switch (e.moduleName) {
					case 'offer_goods':
						if (e.data.column.field == 'computertype') {
							// console.log(e,e.data.row.computertype)
							this.$nextTick(()=>{
								if(e.data.row.computertype == 8105){
									this.computeRow(e.data.row,'rategrossprofit')
								}else{
									this.computeRow(e.data.row,'tmdiscount')
								}
								
							})							
						}
						if (e.data.column.field == 'num') {
							this.computeRow(e.data.row,'num')							
						}
						if (e.data.column.field == 'pretaxfreight') {
							this.computeRow(e.data.row,'pretaxfreight')							
						}
						if (e.data.column.field == 'taxfreight') {
							this.computeRow(e.data.row,'taxfreight')							
						}
						
						if (e.data.column.field == 'preamount') {
							if(!e.data.row.num){
								return
							}
							this.computeRow(e.data.row,'preamount')							
						}
						if (e.data.column.field == 'amount') {
							if(!e.data.row.num){
								return
							}
							this.computeRow(e.data.row,'amount')							
						}						
						if (e.data.column.field == 'rategrossprofit') {
							this.computeRow(e.data.row,'rategrossprofit')							
						}						
						break;
				}
			},

			profitmargin(row) {
				let targetprofit = this.gettargetprofit(row)
				if(!targetprofit){
					return true
				}
				if(!row.preamount){
					return true
				}
				// console.log(targetprofit,row.preamount)
				let profititem = this.getinitialrategrossprofit(targetprofit.goodsprofit_detail,row.preamount)
				let profit = profititem.profit
				row.readrategrossprofit = (parseFloat(profit) - this.config.profitoffsetleft).toFixed(2)

				// console.log(row.readrategrossprofit,row.rategrossprofit)
				if(row.rategrossprofit < row.readrategrossprofit){
					return false
				}else{
					return true
				}			
			},
			contract() {

			},
			canToFixed(value, digits = 4) {
				if (value === null || value === undefined || value === '') {
					return value;
				}
				const num = Number(value);
				if (isNaN(num) || !isFinite(num)) {
					return value;
				}
				return num.toFixed(digits);
			},

			roundPriceAuto(value) {
				const piece = Number(value); // 不再除以 1000，单纯看数字

				let decimalPlaces;
				if (piece >= 10) {
					decimalPlaces = 1;
				} else if (piece >= 5) {
					const secondDecimal = Math.floor((piece + Number.EPSILON) * 100) % 10;
					decimalPlaces = secondDecimal >= 8 ? 1 : 2;
				} else if (piece >= 1) {
					decimalPlaces = 2;
				} else if (piece >= 0.1) {
					decimalPlaces = 3;
				} else if (piece >= 0.01) {
					decimalPlaces = 3;
				} else {
					decimalPlaces = 4;
				}

				const factor = Math.pow(10, decimalPlaces);
				const roundedPiece =
					Math.round((piece + Number.EPSILON) * factor) / factor;
				
				return roundedPiece.toFixed(decimalPlaces)
				
				// return {
				// 	piece: roundedPiece.toFixed(decimalPlaces),
				// 	thousand: String(Number((roundedPiece * 1000).toFixed(6))),
				// 	decimalPlaces,
				// };
			}

		},
		components: {
			formmain,
			print,
			onlinegoodsbox,
			customerbox,
			stockIndex
		}
	}
</script>
